'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { EntityDetail } from './EntityDetail';
import { useEntity } from '@/lib/hooks';
import type { Entity } from '@/lib/api/types';
interface EntityDetailViewProps {
  id: string;
  entityType?: string;
  sidebarPosition?: 'right' | 'left' | 'under-description';
}
export function EntityDetailView(t0) {
  const $ = _c(23);
  const {
    id,
    entityType,
    sidebarPosition
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: entity,
    isPending,
    error
  } = useEntity(id, t1);
  if (isPending) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="text-center py-16"><div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center"><svg className="w-12 h-12 text-gray-400 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg></div><h3 className="text-xl font-semibold text-gray-900 mb-2">Loading...</h3></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (error) {
    let t2;
    if ($[2] !== error) {
      t2 = error instanceof Error && (error.message.includes("404") || error.message.includes("not found"));
      $[2] = error;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const is404 = t2;
    const t3 = is404 ? "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" : "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z";
    let t4;
    if ($[4] !== t3) {
      t4 = <div className="w-24 h-24 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center"><svg className="w-12 h-12 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={t3} /></svg></div>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const t5 = is404 ? "Entity not found" : "Something went wrong";
    let t6;
    if ($[6] !== t5) {
      t6 = <h3 className="text-xl font-semibold text-gray-900 mb-2">{t5}</h3>;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const t7 = is404 ? `We couldn't find an entity matching "${id}". It may have been removed or the URL might be incorrect.` : "We had trouble loading this entity. Please try again later.";
    let t8;
    if ($[8] !== t7) {
      t8 = <p className="text-gray-600 mb-2">{t7}</p>;
      $[8] = t7;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== is404) {
      t9 = is404 && <p className="text-sm text-gray-500 mb-6">Double-check the URL for typos and try again.</p>;
      $[10] = is404;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    let t10;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Link href="/directory" className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors cursor-pointer">Browse directory</Link>;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    let t11;
    if ($[13] !== t4 || $[14] !== t6 || $[15] !== t8 || $[16] !== t9) {
      t11 = <div className="text-center py-16">{t4}{t6}{t8}{t9}{t10}</div>;
      $[13] = t4;
      $[14] = t6;
      $[15] = t8;
      $[16] = t9;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    return t11;
  }
  if (!entity) {
    let t2;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="text-center py-16"><div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center"><svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg></div><h3 className="text-xl font-semibold text-gray-900 mb-2">Entity not found</h3><p className="text-gray-600">The entity you're looking for doesn't exist or has been removed.</p></div>;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    return t2;
  }
  const displayEntityType = entityType || entity.type;
  const resolvedSidebarPosition = sidebarPosition || (entity.data as any)?.main_page?.sidebarPosition || "right";
  let t2;
  if ($[19] !== displayEntityType || $[20] !== entity || $[21] !== resolvedSidebarPosition) {
    t2 = <EntityDetail showConnections={true} entity={entity} entityType={displayEntityType} sidebarPosition={resolvedSidebarPosition} />;
    $[19] = displayEntityType;
    $[20] = entity;
    $[21] = resolvedSidebarPosition;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  return t2;
}
export default EntityDetailView;